module.exports = __webpack_public_path__ + "static/img/reward_icon_01.88f2803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/reward_icon_01.png
// module id = WQNu
// module chunks = 1